import { DialogClose } from './DialogClose';

// TODO: in v9, move styled() from DialogClose.jsx to here
export var StyledDialogClose = DialogClose;